module.exports = __webpack_public_path__ + "static/media/files icon-DOCX.a9e06934.png";